import type { RootState } from 'store';

export const selectIsLoggedIn = (state: RootState) => !!state.user.accessToken;
export const selectIsFetchingUser = (state: RootState) => state.user.fetching;
export const selectUser = (state: RootState) => state.user.user;
